import { createContext, useMemo } from 'react';
import { useFunctions } from './useHelpers/useFunctions';
import { useRenders } from './useHelpers/useRenders';

export const FunctionsContext = createContext();

/**
 * 
 * @param {*} param0 
 * @returns functions_state and functions_fns (fc_notifications, fc_sheets, etc.)
 */
const FunctionsProvider = ({ children }) => {

  const { fn_cls } = useFunctions()

  useRenders('FunctionsProvider', true)

  const functions_cls = useMemo(() => {
    return fn_cls
  }, [fn_cls]);

  return (
    <FunctionsContext.Provider
      value={{
        functions_cls,
      }}
    >
      {children}
    </FunctionsContext.Provider>
  );
};

export default FunctionsProvider;
